import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@common/button";
import { RichTextInput } from "@common/richTextInput";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectModel({
  model: { description, name, uuid },
  useTemplate,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.projectModel}>
      <h3 className={styles.name}>{name}</h3>
      {description && (
        <RichTextInput
          value={description}
          isDisabled
          input={() => {}}
          className={styles.description}
        />
      )}
      <div className={styles.buttons}>
        <Link to={`/projects/${uuid}`} className={styles.edit}>
          {t("projectModelsPage.edit")}
        </Link>
        <Button type="submit" className={styles.button} press={useTemplate}>
          {t("projectModelsPage.use")}
        </Button>
      </div>
    </div>
  );
}

export { ProjectModel };
